export function _hasProperty(obj, prop) {
    const _has = Object.prototype.hasOwnProperty

    return _has.call(obj, prop)
}

export function _isObjEmpty(obj) {
    return obj && Object.keys(obj).length === 0
}

export function formatApplicantName(str: string | undefined) {
    if (str) {
        const words = str.split(" ");
        const romanNumeralRegex = /^[ivxlcdm]+$/i;
        const updatedWords = words.map(word => {
            if (romanNumeralRegex.test(word)) {
                return word.toUpperCase();
            }
            return word;
        });
        return updatedWords.join(" ");
    } else {
        return '';
    }
}

